var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-management-container" },
    [
      _c(
        "div",
        { staticClass: "user-management" },
        [
          _vm.showUserManagementEditBtn
            ? _c(
                "Sticky",
                {
                  staticClass: "sticky-btns",
                  attrs: {
                    fullWidth: false,
                    zIndex: Number(101),
                    align: "right",
                    extendStickyClass: "sticky-state",
                  },
                },
                [
                  _vm.editing
                    ? _c("HKLButton", {
                        staticClass: "no-min-width",
                        attrs: { action: "cancel", color: "darkblue" },
                        on: { click: _vm.cancelEdit },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("HKLButton", {
                        staticClass: "no-min-width",
                        attrs: { action: "save", color: "orange" },
                        on: { click: _vm.doSave },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("HKLButton", {
                        staticClass: "no-min-width",
                        attrs: { action: "edit", color: "orange" },
                        on: { click: _vm.switchEditState },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (!_vm.editing || _vm.createProject) && _vm.isMaster
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn--orange",
                          attrs: { type: "button" },
                          on: { click: _vm.createProject },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("newProject")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user-management-content" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("tenancy.masterTenantAccount"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "master-account" }, [
              _c(
                "div",
                { staticClass: "name" },
                _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                  return _c("InputField", {
                    key: fullnameObj.key,
                    attrs: {
                      placeholder: _vm.$t("contact.basic." + fullnameObj.label),
                      showColon: false,
                      showFlag: fullnameObj.isFirst
                        ? _vm.isEngineerEditing
                        : false,
                      label: fullnameObj.isFirst
                        ? _vm.$t("user.name")
                        : "lastname",
                      value:
                        (_vm.masterAccount.TenancyAccount &&
                          _vm.masterAccount.TenancyAccount[
                            "contact" + fullnameObj.key
                          ]) ||
                        "",
                      readonly: !_vm.isEngineerEditing,
                      readonlyAsInput:
                        _vm.isEngineer &&
                        !_vm.allowUpdateMasterAccount &&
                        _vm.editing,
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.changeMasterAccountName(
                          "contact" + fullnameObj.key,
                          val
                        )
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "account-email" },
                [
                  _c("InputField", {
                    attrs: {
                      label: _vm.$t("user.accountEmail"),
                      showColon: false,
                      showFlag: _vm.isEngineerEditing,
                      value: _vm.masterAccount.username,
                      pattern: _vm.regex.email,
                      inputTip: _vm.errorEmail,
                      readonly: !_vm.isEngineerEditing,
                      readonlyAsInput:
                        _vm.isEngineer &&
                        !_vm.allowUpdateMasterAccount &&
                        _vm.editing,
                      required: true,
                    },
                    on: {
                      updateValue: function (val) {
                        return _vm.changeMasterAccountUsername(val)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            !_vm.editing
              ? _c("div", { staticClass: "btns" }, [
                  _vm.isEngineer && _vm.allowInviteMaster
                    ? _c(
                        "button",
                        {
                          staticClass: "invite-master-user btn btn--darkblue",
                          on: { click: _vm.openMasterInviteModal },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenancy.inviteMasterUser")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMaster
                    ? _c(
                        "button",
                        {
                          staticClass: "reset-password btn btn--darkblue",
                          on: { click: _vm.resetPassword },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenancy.resetPassword")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canRequestForInvitation
                    ? _c(
                        "button",
                        {
                          directives: [
                            { name: "hkldreset", rawName: "v-hkldreset" },
                          ],
                          staticClass: "btn btn--darkblue edit",
                          class: { "tenant-edit": _vm.canRequestForInvitation },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.sendRequest()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("action.requestForInvitation")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "show-all-users" }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("tender.tenancyUser")) +
                  " " +
                  _vm._s(_vm.isEngineer ? _vm.$t("tender.tenantMaintain") : "")
              ),
            ]),
            _vm._v(" "),
            _c("table", [
              _c("thead", [
                _c(
                  "tr",
                  [
                    _vm._l(_vm.filteredTableElements, function (item, index) {
                      return _c(
                        "th",
                        { key: index },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.title.toUpperCase()) +
                              "\n              "
                          ),
                          item.popover
                            ? _c("Popover", { attrs: { text: item.popover } })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.isTenant ? _c("th") : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.allAccounts, function (item, index) {
                  return _c("tr", { key: index }, [
                    _c(
                      "td",
                      { staticClass: "username" },
                      [
                        _c("InputField", {
                          attrs: {
                            showColon: false,
                            showFlag: false,
                            value: item.username,
                            pattern: _vm.regex.email,
                            inputTip: _vm.errorEmail,
                            readonly:
                              _vm.isAdmin(item) ||
                              !_vm.isUserTableEditing(item),
                            required: true,
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.changeSubAccountUserName(item, val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "name" }, [
                      !_vm.isUserTableEditing(item)
                        ? _c("div", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getFullName(item)) +
                                "\n              "
                            ),
                          ])
                        : _c(
                            "div",
                            { staticClass: "editing-name" },
                            _vm._l(
                              _vm.getFullnameSorts,
                              function (fullnameObj) {
                                return _c("InputField", {
                                  key: fullnameObj.key,
                                  attrs: {
                                    showColon: false,
                                    showFlag: false,
                                    value:
                                      item.TenancyAccount[
                                        "contact" + fullnameObj.key
                                      ],
                                    readonly: _vm.isAdmin(item),
                                    required: true,
                                    placeholder: _vm.$t(
                                      "contact.basic." + fullnameObj.label
                                    ),
                                  },
                                  on: {
                                    updateValue: function (val) {
                                      return _vm.changeSubAccountName(
                                        item,
                                        "contact" + fullnameObj.key,
                                        val
                                      )
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.isAdmin(item)
                        ? _c("input", {
                            attrs: { type: "checkbox", disabled: "true" },
                            domProps: { checked: _vm.isAdmin(item) },
                          })
                        : _c("span", [_vm._v("-")]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.isUserTableEditing(item) ||
                      !!item.TenancyAccount.perms[
                        _vm.TenancySubAccountPermKeys.SubAdmin
                      ]
                        ? _c("input", {
                            attrs: {
                              type: "checkbox",
                              disabled:
                                _vm.isAdmin(item) ||
                                _vm.isEngineer ||
                                !_vm.isUserTableEditing(item),
                            },
                            domProps: {
                              checked:
                                !!item.TenancyAccount.perms[
                                  _vm.TenancySubAccountPermKeys.SubAdmin
                                ],
                            },
                            on: {
                              change: function () {
                                return _vm.changePerms(
                                  item,
                                  _vm.TenancySubAccountPermKeys.SubAdmin
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v("-")]),
                    ]),
                    _vm._v(" "),
                    _vm.enableTenantProjectsFeature
                      ? _c("td", [
                          _vm.isUserTableEditing(item) ||
                          !!item.TenancyAccount.perms[
                            _vm.TenancySubAccountPermKeys.TenantProject
                          ]
                            ? _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    _vm.isAdmin(item) ||
                                    _vm.isEngineer ||
                                    !_vm.isUserTableEditing(item),
                                },
                                domProps: {
                                  checked:
                                    !!item.TenancyAccount.perms[
                                      _vm.TenancySubAccountPermKeys
                                        .TenantProject
                                    ],
                                },
                                on: {
                                  change: function () {
                                    return _vm.changePerms(
                                      item,
                                      _vm.TenancySubAccountPermKeys
                                        .TenantProject
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableTenantProjectsFeature
                      ? _c("td", [
                          _vm.isUserTableEditing(item) ||
                          !!item.TenancyAccount.perms[
                            _vm.TenancySubAccountPermKeys.HandoverTakeback
                          ]
                            ? _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    _vm.isAdmin(item) ||
                                    _vm.isEngineer ||
                                    !_vm.isUserTableEditing(item),
                                },
                                domProps: {
                                  checked:
                                    !!item.TenancyAccount.perms[
                                      _vm.TenancySubAccountPermKeys
                                        .HandoverTakeback
                                    ],
                                },
                                on: {
                                  change: function () {
                                    return _vm.changePerms(
                                      item,
                                      _vm.TenancySubAccountPermKeys
                                        .HandoverTakeback
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableWorkPermitsFeature
                      ? _c("td", [
                          _vm.isUserTableEditing(item) ||
                          !!item.TenancyAccount.perms[
                            _vm.TenancySubAccountPermKeys.StandaloneWorkPermits
                          ]
                            ? _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    _vm.isAdmin(item) ||
                                    _vm.isEngineer ||
                                    !_vm.isUserTableEditing(item),
                                },
                                domProps: {
                                  checked:
                                    !!item.TenancyAccount.perms[
                                      _vm.TenancySubAccountPermKeys
                                        .StandaloneWorkPermits
                                    ],
                                },
                                on: {
                                  change: function () {
                                    return _vm.changePerms(
                                      item,
                                      _vm.TenancySubAccountPermKeys
                                        .StandaloneWorkPermits
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableTenancyRecordsFeature
                      ? _c("td", [
                          _vm.isUserTableEditing(item) ||
                          !!item.TenancyAccount.perms[
                            _vm.TenancySubAccountPermKeys.TenancyRecord
                          ]
                            ? _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    _vm.isAdmin(item) ||
                                    _vm.isEngineer ||
                                    !_vm.isUserTableEditing(item),
                                },
                                domProps: {
                                  checked:
                                    !!item.TenancyAccount.perms[
                                      _vm.TenancySubAccountPermKeys
                                        .TenancyRecord
                                    ],
                                },
                                on: {
                                  change: function () {
                                    return _vm.changePerms(
                                      item,
                                      _vm.TenancySubAccountPermKeys
                                        .TenancyRecord
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.enableGreenOperationFeature
                      ? _c("td", [
                          _vm.isUserTableEditing(item) ||
                          !!item.TenancyAccount.perms[
                            _vm.TenancySubAccountPermKeys.GreenOperation
                          ]
                            ? _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    _vm.isAdmin(item) ||
                                    _vm.isEngineer ||
                                    !_vm.isUserTableEditing(item),
                                },
                                domProps: {
                                  checked:
                                    !!item.TenancyAccount.perms[
                                      _vm.TenancySubAccountPermKeys
                                        .GreenOperation
                                    ],
                                },
                                on: {
                                  change: function () {
                                    return _vm.changePerms(
                                      item,
                                      _vm.TenancySubAccountPermKeys
                                        .GreenOperation
                                    )
                                  },
                                },
                              })
                            : _c("span", [_vm._v("-")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", { staticClass: "lastLoginAt" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.formatDate(item.lastLoginAt)) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "invitedAt" }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(item.TenancyAccount.invitedAt) || "-"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isAdmin(item) && _vm.isUserTableEditing(item)
                        ? _c("i", {
                            staticClass: "fa fa-times fa-lg",
                            on: {
                              click: function ($event) {
                                return _vm.showDeleteModal(index)
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isMaster ||
                    (_vm.isTenancySubAdmin && !_vm.isCurrentUser(item))
                      ? _c("td", [
                          !_vm.editing && !_vm.isAdmin(item)
                            ? _c(
                                "button",
                                {
                                  staticClass: "invite btn btn--darkblue",
                                  on: {
                                    click: function ($event) {
                                      return _vm.inviteSubAccount(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("action.invite")) +
                                      "\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.isUserTableEditing()
              ? _c(
                  "i",
                  {
                    staticClass: "addBtn",
                    on: {
                      click: function ($event) {
                        return _vm.addNewSubTenancyUser()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("userManagement.addNewTenancyUser")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.enableWorkPermitsFeature
            ? _c("TenancyContractors", {
                attrs: {
                  isEditing: _vm.editing,
                  hasSWPRight: _vm.hasTenantSwpRight,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isHKlandUser ? _c("RepresentativeVue") : _vm._e(),
          _vm._v(" "),
          _c("modal", { ref: "deleteUserManagementCommitModal" }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _c("p", { staticClass: "modal-pure-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("userManagement.deleteUserTips")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
              _c(
                "button",
                {
                  staticClass: "cancel btn btn--darkblue",
                  on: { click: _vm.closeDeleteModal },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.cancel")) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "comfirm btn btn--orange",
                  on: { click: _vm.deleteAccount },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("action.delete")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("TenantsInviteModalVue", { ref: "tenantsInviteModal" }),
      _vm._v(" "),
      _c("MasterInviteModal", {
        ref: "masterInviteModal",
        attrs: { masterAccount: _vm.masterAccount },
        on: { inviteClick: _vm.doInviteMasterAccount },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }